export default __webpack_public_path__ + "static/media/soldout.7d146520.svg";